$(document).ready(function() {

	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
	    }
	    return null;
	} 

	function createCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires;
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	function eraseCookie(name) {
		createCookie(name,"",-1);
	}

	//detects if under ie9 and displays a message.
	var ie = (function(){
	    var undef,
	        v = 3,
	        div = document.createElement('div'),
	        all = div.getElementsByTagName('i');

	    while (
	        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
	        all[0]
	    );
	    return v > 4 ? v : undef;
	}());

	if (ie < 9 ){
		var popupCookie = getCookie("rememberpopup");
		if (popupCookie == null){
			var message = "<div class='browser-message'>\
						   <h3>Browser outdated.</h3>\
						   <p>You are using an outdated browser. To get the best experience from this website install Chrome, Firefox or Internet Explore 9+. Thank you.</p>\
						   <span class='btn js-message-close'>Close</span>\
						   <p><small>*By closing this message you accept the use of cookies on this website.</small></p>\
					   </div>",
			messageOverlay = "<div class='message-overlay'></div>";
				
			$(message).appendTo('.message-overlay');
			$('.message-overlay').show();
		}
	}

	$('.js-message-close').on('click', function(){
		createCookie('rememberpopup','Remember Popup',1);
		//readCookie(rememberpopup);
		$('.message-overlay').hide();
	});


	$('a[rel^="external"]').click( function() {
		window.open( $(this).attr('href') );
		return false;
	});

	$('.menu-btn').on('click', function(){
		$('body').toggleClass('active-nav');
	});

	$(window).resize(resize);


	$('body').on('submit', '#contact-form', function(){
		$(this).find(".loading-errors").html('<img src="/images/gif/ajax-loader.gif">');
		$('.error-container').removeClass('error-container');
		$('input').removeClass('error');

		var data = $(this).serialize();
		data = data + '&ajax=true';

		$.ajax({
			url: $(location).attr('href'),
			data: data,
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message. 
					if(data.success == false) { 
						var error_message = $('<span>').addClass('error')
									.append($('<span>').addClass('icon'))
									.append($('<span>').addClass('text').text(data.error[0].message));
						$(this).find(".loading-errors").html(error_message);
						$(this).find('input[name="' + data.error[0].field + '"]').addClass('error-input');
						$('body').animate({scrollTop: $("#form").offset().top - 80},"slow");
					} else {
						$("#form").html(data.success);
					}
				} else {
					alert("There was a problem, sorry!");
				}
			}.bind(this),
			dataType: "json"
		});
		
		return false;

	});

	$('html').attr('data-useragent', navigator.userAgent);

});

$(window).bind("load", function () {

});

$(window).on("scroll",function(){
	
});

function resize() {

}

function check_width_max(maxwidth) {
    /**** CHECKS THAT THE WINDOW IS NARROWER THAN MAXWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) <= parseInt(maxwidth);
}

function check_width_min(minwidth) {
    /**** CHECKS THAT THE WINDOW IS WIDER THAN MINWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) >= parseInt(minwidth);
}

function check_height_max(maxheight) {
    /**** CHECKS THAT THE WINDOW IS SMALLER THAN MAXHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) <= parseInt(maxheight);
}

function check_height_min(minheight) {
    /**** CHECKS THAT THE WINDOW IS TALLER THAN MINHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) >= parseInt(minheight);
}

function matchHeights() {
   var classes = ['same_height', 'same_height_2', 's_height'];
   var height = 0;
   if (check_width_min(600)) {
       $.each(classes, function (_, className) {
           height = 0;
           $('.' + className).css("min-height", "");
           if(check_height_min(760) && check_width_min(760)){
               if(className === 'same_height_2'){
                   return;
               }
           }
           $('.' + className).each(function (i, obj) {
               if ($(this).outerHeight() > height) {
                   height = $(this).outerHeight();
               }
           });
           $('.' + className).css("min-height", height);
       });
   } else {
       $.each(classes, function (_, className) {
           $('.' + className).css("min-height", "");
       });
   }
}